import { useTranslation } from '../../i18n/i18n';
import { ApiCartItem } from '../../types';
import { CartItem } from './CartItem';
import './CartItem.css';

type CartItemListingProps = {
	items: ApiCartItem[];
	onSetQuantity: (id: number, quantity: number) => void;
};

export const CartItemListing = ({ items, onSetQuantity }: CartItemListingProps): JSX.Element => {
	const t = useTranslation().cart;
	if (items.length === 0) return <p className="empty-cart-text text-center">{t.cartEmpty}</p>;

	return (
		<>
			{items.map((item) => (
				<CartItem key={item.product.id} item={item} onSetQuantity={onSetQuantity} />
			))}
		</>
	);
};
